import { styled } from '@mui/material/styles'
import { GridLegacy as Grid } from '@mui/material'
import React, { ReactNode } from 'react'
import { InfoTooltip } from 'ComponentLibrary/src/atoms/IconTooltip'
import { Typography } from 'ComponentLibrary/src/piazza'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

interface Row {
    label: string
    value: ReactNode
    greyedOut?: boolean
    tooltip?: string
}

export interface TabularInfoProps {
    rows: Row[]
    labelMinWidth?: string
}

const ContainerGrid = styled(Grid, {
    shouldForwardProp: (prop) => prop !== 'labelMinWidth',
})<{ labelMinWidth?: string }>(({ labelMinWidth }) => ({
    display: 'grid',
    gridTemplateColumns: labelMinWidth ? `minmax(${labelMinWidth}, max-content) 1fr` : 'min-content 1fr',
    gap: `${tokens.SizingSpacing200} ${tokens.SizingSpacing300}`,
}))

const RowItem = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: '1 / -1',
    alignItems: 'center',
})

export default function TabularInfo({ rows, labelMinWidth }: TabularInfoProps) {
    return (
        <ContainerGrid item labelMinWidth={labelMinWidth}>
            {rows.map(({ label, value, greyedOut, tooltip }) => (
                <RowItem key={`${label} ${value}`}>
                    <Typography variant="textS" color={tokens.ColorTextDefault} noWrap>
                        {label}
                    </Typography>
                    {typeof value === 'string' ? (
                        <Typography
                            variant="textS"
                            color={greyedOut || value === '' || value === undefined ? tokens.ColorTextDisabled : tokens.ColorTextBold}
                        >
                            {value === '' || value === undefined ? '-' : value}
                            {tooltip && <InfoTooltip style={{ margin: '-8px 4px' }} text={tooltip} />}
                        </Typography>
                    ) : (
                        <>
                            {value === '' || value === undefined ? '-' : value}
                            {tooltip && <InfoTooltip style={{ margin: '-8px 4px' }} text={tooltip} />}
                        </>
                    )}
                </RowItem>
            ))}
        </ContainerGrid>
    )
}
